"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandymanProvince = void 0;
var zod_1 = require("zod");
var HandymanProvince;
(function (HandymanProvince) {
    HandymanProvince.Schema = zod_1.z.object({
        name: zod_1.z.string(),
        counties: zod_1.z.string().array(),
    });
})(HandymanProvince || (HandymanProvince = {}));
exports.HandymanProvince = HandymanProvince;
